import { useNavigate, useLocation } from 'react-router-dom';
import { useCredits } from '../services/credits-service.js';
import { useLocale } from '../hooks/useLocale.jsx';
import { TABS, logTabClick } from './MobileTabBar.jsx';
import { isLandingPath } from '../utils/landing-paths.js';

// 데스크톱 헤더 (2.3.0) — 모바일 탭바와 **같은 다섯 칸**을 같은 순서로 둔다:
//   갤러리 · 내 페이지 · [만들기] · 디자이너 · 설정
// 예전엔 갤러리·디자이너 링크 두 개에 나머지는 아바타 드롭다운(내 디자인·컬렉션·
// 계정·초대·로그아웃) 안에 숨어 있어서, 드롭다운을 열기 전엔 Gio 가 있는지도
// 몰랐다. 이제 전부 밖에 나와 있고, 버튼은 아이콘+글자 알약이라 누르기 쉽다.
// 로그아웃·초대·프로필은 설정(/account) 안에 있다. 컬렉션은 진입점을 뗐다
// (라우트는 남겨 기존 링크는 열린다).
export function Header({ user, onSignInRequest, onCreditsClick }) {
  const credits = useCredits();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useLocale();
  const authLoading = user === undefined;
  const isLoggedIn = !authLoading && user && !user.isAnonymous;

  // 마케팅 landing 은 full-bleed — app chrome 모두 숨김.
  if (isLandingPath(pathname)) return null;

  return (
    <header className="header">
      <button className="header-logo" onClick={() => navigate('/')}>
        {t('appName')}
      </button>
      <nav className="header-tabs" aria-label={t('navMain')}>
        {TABS.map((tab) => {
          const active = tab.match(pathname);
          const avatar = tab.key === 'account' && isLoggedIn && user.photoURL;
          return (
            <button
              key={tab.key}
              type="button"
              data-tour={`nav-${tab.key}`}
              className={`header-tab${tab.center ? ' header-tab--create' : ''}${active ? ' active' : ''}`}
              onClick={() => { logTabClick(tab.key, 'desktop'); navigate(tab.path); }}
              aria-current={active ? 'page' : undefined}
              title={t(tab.labelKey)}
            >
              {avatar
                ? <img src={user.photoURL} alt="" className="header-tab-avatar" referrerPolicy="no-referrer" />
                : <i className="material-symbols-rounded" aria-hidden="true">{tab.center ? 'add' : tab.icon}</i>}
              <span>{t(tab.labelKey)}</span>
            </button>
          );
        })}
      </nav>
      <div className="header-side">
        {/* 크레딧 잔액 — 0 이 되고 나서야 알게 되면 곤란하다. 눌러서 CreditModal.
            Pro 는 무제한이라 숨긴다. 게스트도 보여준다 (모바일 칩과 같은 규칙). */}
        {!credits.loading && credits.plan !== 'pro' && (
          <button
            type="button"
            className={`header-credit-chip${credits.credits <= 0 ? ' is-empty' : ''}`}
            onClick={() => onCreditsClick?.()}
            aria-label={t('creditsAria', { n: credits.credits })}
          >
            <i className="material-symbols-rounded">bolt</i>
            <span>{credits.credits}</span>
          </button>
        )}
        {authLoading
          ? <div className="header-auth-placeholder" aria-hidden="true" />
          : !isLoggedIn && (
            <button type="button" className="btn btn-secondary header-nav-btn" onClick={() => onSignInRequest?.()}>
              <i className="material-symbols-rounded">login</i>
              <span>{t('signIn')}</span>
            </button>
          )}
      </div>
    </header>
  );
}
